import { CircularProgress, CircularProgressProps } from '@mui/material'
import classNames from 'classnames'

import style from './LoaderInCentalPosition.module.scss'

type TLoaderInCentalPosition = {
  className?: string
  props?: CircularProgressProps
}
// Лоадер
export function LoaderInCentalPosition({
  className,
  props,
}: TLoaderInCentalPosition) {
  return (
    <CircularProgress
      className={classNames(style.loader, className)}
      {...props}
    />
  )
}
